import React from 'react';
import listAsString from 'utils/listAsString';
import formatDateLong from 'utils/formatDateLong';
import formatTime from 'utils/formatTime';
import ordinalNumber from 'utils/ordinalNumber';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import {validate as validateTime} from 'records/Time';

const DAYS_IN_ORDER = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export default class ScheduleDescription extends React.PureComponent {
  render() {
    const {schedule} = this.props;
    const startDate = moment(schedule.time.toJS());
    const endDate = schedule.getEffectiveEndDate();
    const difference = Math.max(1, Math.ceil(endDate && endDate.diff(startDate, 'days') / 7));
    const timeIsValid = isEmpty(validateTime(schedule.time));
    const sortedDaysOfWeek = schedule.daysOfWeek.sortBy(day => DAYS_IN_ORDER.indexOf(day));
    const unit = difference > 1 ? 'weeks' : 'week';
    return (
      <p>
        {endDate && (
          <span>
            Your coaching plan spans {difference} {unit} between {formatDateLong(startDate)} and{' '}
            {formatDateLong(endDate)}.{' '}
          </span>
        )}
        {schedule.daysOfWeek.size > 0 && timeIsValid && (
          <span>
            You’ll meet{' '}
            {schedule.weeksBetween > 1 ? 'every ' + ordinalNumber(schedule.weeksBetween) : 'each'}{' '}
            {listAsString(sortedDaysOfWeek)} at {formatTime(startDate)}.
          </span>
        )}
      </p>
    );
  }
}
